import { render, staticRenderFns } from "./DiscountAlert.vue?vue&type=template&id=693ae97c&"
import script from "./DiscountAlert.vue?vue&type=script&lang=js&"
export * from "./DiscountAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports